import { render, staticRenderFns } from "./ParatonerPage.vue?vue&type=template&id=7c2168cd&scoped=true&"
import script from "./ParatonerPage.vue?vue&type=script&lang=js&"
export * from "./ParatonerPage.vue?vue&type=script&lang=js&"
import style0 from "./ParatonerPage.vue?vue&type=style&index=0&id=7c2168cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2168cd",
  null
  
)

export default component.exports